var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackmoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 248,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #042b62;\n      }\n\n      .cls-3 {\n        fill: #3b404b;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        font-size: 69.08px;\n      }\n\n      .cls-5, .cls-2 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n      }\n\n      .cls-6 {\n        fill: #cdcdce;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        fill: #fdfdfe;\n      }\n\n      .cls-9 {\n        fill: #ebebeb;\n      }\n\n      .cls-10 {\n        fill: none;\n        stroke: #777;\n        stroke-dasharray: 22;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        font-size: 87.64px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 231.5,
    cy: 317.5,
    rx: 52.5,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 870.5,
    cy: 855.5,
    rx: 52.5,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M607.34,448.27c49.4,0,98.81-.33,148.21.1,46.04.4,70.91,44.73,48.63,85.19-9.33,16.94-24.69,24.02-42.14,24.9-16.76.84-29.12,7.15-37.86,20.59-5.94,9.14-11.22,7.44-16.94.68-15.01-17.73-34.44-21.37-56.74-21.06-64.54.88-129.1.41-193.65.25-20.73-.05-39.22-5.47-49.99-25.28-11.27-20.74-10.77-41.68.99-61.95,11.42-19.69,31.25-22.97,51.29-23.21,49.4-.59,98.8-.19,148.21-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M558.79,599.2h18.44c.06.71.11,1.41.17,2.12h-19.23c.21-.71.42-1.41.62-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305,317h496.98c14.12,1.41,53.72,7.13,88.69,37.21,45.86,39.44,49.55,91.34,50.07,102,.7,9.45,3.17,56.6-34.09,98-37.58,41.76-88.08,47.13-98,48-140.77-.91-281.54-1.83-422.31-2.74-8.68-1.57-76.68-12.76-130.54,31.74-36.28,29.97-45.46,68.11-47.94,81-.45,19.99,2.99,44.49,17.04,68,31.61,52.86,105.05,80.85,186.27,72.29,130.14-.06,260.28-.11,390.42-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.28,843.74c-16.79-31.89-34.28-63.44-50.17-95.78-15.62-31.79-1.25-68.58,30.72-82.4,31.96-13.82,68.83,1.76,80.64,34.74,6.77,18.9,4.11,37.28-5.49,54.99-15.92,29.36-31.39,58.97-47.04,88.47-2.9,10.12-5.77,3.28-8.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M870.43,763.9c-25.24.14-45.27-19.15-45.82-44.13-.57-25.59,20.04-47.1,45.22-47.21,24.95-.11,46.48,21.67,46.07,46.62-.4,24.71-20.61,44.58-45.46,44.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.2,312c-12.9-32.53-32.48-61.59-48.08-92.72-12.16-24.25-11.25-47.46,5.93-68.39,15.87-19.33,36.94-27.11,61.85-20.74,26.58,6.8,40.9,25.1,45.7,51.32,2.89,15.76-3.27,29.59-10.26,43.28-14.92,29.23-33.61,56.52-45.11,87.5-.59,1.93-1.86,3.16-3.8,3.69-2.95.06-5.72-.17-6.23-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M231.43,234.9c-25.24.14-45.27-19.15-45.82-44.13-.57-25.59,20.04-47.1,45.22-47.21,24.95-.11,46.48,21.67,46.07,46.62-.4,24.71-20.61,44.58-45.46,44.72Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(494.11 529.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.2,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 55.54,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 86.07,
    y: 0
  }, "ome")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(848.08 749.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackmoney);
export default __webpack_public_path__ + "static/media/Trackmoney.a40ad13c0d6038634a1628537b5e1acb.svg";
export { ForwardRef as ReactComponent };